import _ from 'lodash';
import React, {useContext} from 'react';
import {useSelector} from 'react-redux';
import {FormattedMessage, useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';

import './RequestPayment.scss';
import Separator from 'components/common/Separator/Separator';
import {useResetWindowScroll} from 'hooks/useResetWindowScroll';
import * as requestSelectors from 'redux/requestPage/request/selectors';
import {useRequestCurrentLangCommunication} from '../../hooks/useRequestCurrentLangCommunication';
import {RequestDoctorCard} from '../RequestDoctorCard/RequestDoctorCard';
import {RequestInfo} from '../../../../components/request/RequestInfo/RequestInfo';
import {RequestManagerContext} from '../RequestManager/RequestManagerContext';
import {RequestNote} from '../RequestNote/RequestNote';
import {RequestPageHeader} from '../RequestPageHeader/RequestPageHeader';
import {SidePanel} from 'components/SidePanel/SidePanel';
import {InfoPanel} from 'components/InfoPanel/InfoPanel';
import {useAppSelector} from 'hooks/use-app-selector';

import DeclineRequestButton from '../common/DeclineRequestButton';
import Button from 'components/common/Button/Button';
import {useTranslation} from 'libs/hooks/use-translation';

export const RequestPayment = () => {
	const requestManager = useContext(RequestManagerContext);
	const dispatch = useDispatch();
	const intl = useIntl();
	const {t} = useTranslation();

	const requestData = useSelector(requestSelectors.getRequestData);
	const currentLang = useRequestCurrentLangCommunication();

	const paymentForm = useAppSelector(requestSelectors.getPaymentForm);
	const doctorText = _.get(requestData.text, requestData.lang);

	const handleSaveAndExit = async () => {
		// confirmation email information modal disabled, go straight to success page
		// payment currently processed off platform
		// can only be confirmed by doctor/request coordinator
		requestManager.goNextPage();
	};

	useResetWindowScroll();

	return (
		<React.Fragment>
			<div className="Request-page__main Request-payment-page">
				<RequestPageHeader
					title={intl.formatMessage({id: 'request.request_title'})}
				/>
				<div className="Request-page__body">
					<h2 className="Request-page__title">
						<FormattedMessage id={'request.payment.title'} />
					</h2>
					<RequestDoctorCard
						doctor={requestData.doctor || {}}
						isConsultTranslate={
							_.get(currentLang, 'translate', false) ||
							!!_.get(
								requestData.doctor,
								['consult', 'translate'],
								false,
							)
						}	
						isSelectable={false}
					/>
					{doctorText && <RequestNote text={doctorText} />}
					<Separator className="mt-2" />
					<RequestInfo data={requestData} currentLang={currentLang} />
					<Separator className="mt-3" />
					{/* <PaymentForm /> попросили временно отключить, вернуть кнопки ниже*/}

					<div className="Flex-row Justify-center Align-center mt-5 mb-4">
						<DeclineRequestButton />
						<Button
							className="ml-2"
							onClick={handleSaveAndExit	}>
							<FormattedMessage
								id={'request.buttons.pay'}
								values={{
									sum: paymentForm.outSum,
									currencySymbol:
										paymentForm.currencySymbol || '—',
								}}
							/>
						</Button>
					</div>
				</div>
			</div>
			<SidePanel className="Request-payment-page__side-panel">
				<InfoPanel
					message={intl.formatMessage({
						id: 'request.payment.panel_message',
					})}
				/>
			</SidePanel>
		</React.Fragment>
	);
};
